import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { generateBaseItems, generateRamItems, getDisk } from '../../../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var GuaranteedPartItem = {
  '10': '10',
  '30': '30',
  '100': '100'
};
var guaranteedPartCards = [{
  value: GuaranteedPartItem[10],
  label: '10% доля',
  description: 'Для тестирования и несложных приложений'
}, {
  value: GuaranteedPartItem[30],
  label: '30% доля',
  description: 'Для стандартной рабочей нагрузки'
}, {
  value: GuaranteedPartItem[100],
  label: '100% доля',
  description: 'Для высоконагруженных сервисов'
}];
var osItems = ['CentOS 7', 'CentOS 7 kernel 5.4', 'CentOS 7 kernel 5.4 v2', 'CentOS 8', 'CentOS 9', 'Debian 12', 'Fedora 38', 'Ubuntu 18.04', 'Ubuntu 20.04', 'Ubuntu 22.04', 'openSUSE 15.2'];
var guaranteedPartToVCpuMap = _defineProperty(_defineProperty(_defineProperty({}, GuaranteedPartItem[10], [1, 2, 4, 8]), GuaranteedPartItem[30], [1, 2, 4, 8, 16, 24, 32]), GuaranteedPartItem[100], [1, 2, 4, 8, 16, 24, 32, 64]);
var guaranteedPartVCpuToRamMap = _defineProperty(_defineProperty(_defineProperty({}, GuaranteedPartItem[10], {
  '1': [1, 2],
  '2': [4],
  '4': [8, 16, 32],
  '8': [16, 32]
}), GuaranteedPartItem[30], {
  '1': [1, 2],
  '2': [4],
  '4': [8, 16, 32, 64],
  '8': [16, 32, 64],
  '16': [32, 64],
  '24': [48],
  '32': [64]
}), GuaranteedPartItem[100], {
  '1': [1, 2],
  '2': [4],
  '4': [8, 16, 32, 64],
  '8': [16, 32, 64, 128],
  '16': [32, 64, 128, 256],
  '24': [32, 48],
  '32': [64, 128, 256],
  '64': [128, 256]
});
export var EVOLUTION_CLOUD_SERVER_FORM_CONFIG = {
  ui: ['alertStart', 'guaranteedPart', ['os'], ['vCpuCoreCount', 'ramAmount'], ['systemDisk'], 'alertAdditional', ['additionalDisks'], 'networkIsNeeded'],
  controls: {
    alertStart: {
      type: CONTROL.Alert,
      uiProps: {
        appearance: 'info',
        outline: true,
        description: /*#__PURE__*/_jsxs(_Fragment, {
          children: ["\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0441\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E \u0441\xA0\u0431\u043E\u043D\u0443\u0441\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043E\u0439 Cloud.ru", /*#__PURE__*/_jsx("br", {}), "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C 4000 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\xA0\u043F\u0435\u0440\u0432\u0443\u044E \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0443 \u043A\u0430\u0440\u0442\u044B."]
        })
      },
      accessorKey: 'start'
    },
    guaranteedPart: {
      decoratorProps: {
        label: 'Гарантированная доля vCPU',
        labelTooltip: 'Гарантированная доля vCPU определяет долю использования процессора, выделенную для виртуальной машины. Этот параметр известен также как переподписка vCPU (vCPU Overcommitment). При 100% гарантируется использование полной мощности виртуальных ядер процессора хоста виртуализации, выделенных виртуальной машине.'
      },
      type: CONTROL.Carousel,
      accessorKey: 'guaranteedPart',
      defaultValue: GuaranteedPartItem[10],
      items: guaranteedPartCards
    },
    os: {
      type: CONTROL.SelectSingle,
      decoratorProps: {
        label: 'Операционная система'
      },
      accessorKey: 'os',
      defaultValue: 'Ubuntu 22.04',
      items: generateBaseItems(osItems)
    },
    vCpuCoreCount: {
      type: CONTROL.Slider,
      accessorKey: 'vCpuCoreCount',
      defaultValue: '1',
      items: [1, 2, 4, 8],
      decoratorProps: {
        label: 'Количество ядер vCPU',
        labelTooltip: 'Количество ядер vCPU'
      },
      watchedControls: {
        guaranteedPart: 'guaranteedPart'
      },
      relateFn: function relateFn(_ref) {
        var guaranteedPart = _ref.guaranteedPart;
        var items = guaranteedPartToVCpuMap === null || guaranteedPartToVCpuMap === void 0 ? void 0 : guaranteedPartToVCpuMap[guaranteedPart];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: items
          };
        }
      }
    },
    ramAmount: {
      type: CONTROL.Segmented,
      decoratorProps: {
        label: 'Количество оперативной памяти (RAM)'
      },
      defaultValue: '1',
      items: generateRamItems([1, 2]),
      accessorKey: 'ramAmount',
      watchedControls: {
        guaranteedPart: 'guaranteedPart',
        vCpuCoreCount: 'vCpuCoreCount'
      },
      relateFn: function relateFn(_ref2) {
        var _guaranteedPartVCpuTo2;
        var guaranteedPart = _ref2.guaranteedPart,
          vCpuCoreCount = _ref2.vCpuCoreCount;
        var items = guaranteedPartVCpuToRamMap === null || guaranteedPartVCpuToRamMap === void 0 ? void 0 : (_guaranteedPartVCpuTo2 = guaranteedPartVCpuToRamMap[guaranteedPart]) === null || _guaranteedPartVCpuTo2 === void 0 ? void 0 : _guaranteedPartVCpuTo2[vCpuCoreCount];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateRamItems(items)
          };
        }
      }
    },
    systemDisk: getDisk({
      space: {
        label: 'Загрузочный диск',
        accessorKey: 'evs.systemDisk.diskSpace',
        defaultValue: 10,
        uiProps: {
          min: 10,
          max: 4096
        }
      },
      specification: {
        accessorKey: 'evs.systemDisk.specification',
        defaultValue: 'SSD',
        uiProps: {
          disabled: true
        }
      }
    }),
    alertAdditional: {
      type: 'alert',
      uiProps: {
        appearance: 'info',
        outline: true,
        description: 'Можно добавить до 7 дополнительных дисков'
      },
      accessorKey: 'risks'
    },
    additionalDisks: {
      type: CONTROL.Array,
      max: 7,
      accessorKey: 'evs.additionalDisks',
      defaultValue: [],
      addText: 'Добавить диск',
      ui: ['disk'],
      controls: {
        disk: getDisk({
          space: {
            label: 'Дополнительный диск',
            accessorKey: 'diskSpace',
            defaultValue: 10,
            uiProps: {
              min: 10,
              max: 4096
            }
          },
          specification: {
            accessorKey: 'specification',
            defaultValue: 'SSD',
            uiProps: {
              disabled: true
            }
          }
        })
      }
    },
    networkIsNeeded: {
      type: CONTROL.Toggle,
      defaultValue: false,
      accessorKey: 'networkIsNeeded',
      decoratorProps: {
        label: 'Аренда публичного IP'
      }
    },
    // Hidden
    network: {
      type: CONTROL.Object,
      defaultValue: {
        ipQuantity: 1,
        bindingIpAddressesQuantity: 0,
        publicGatewayQuantity: 0,
        privateGatewayQuantity: 0
      },
      ui: [],
      controls: {},
      visible: false
    }
  }
};